<template>
  <div v-if="data.userdata && data.updateData">
    <div>
      <strong>บัตรประชาชน</strong><br />
      {{ data.userdata.IDCard }}
    </div>
    <br />
    <div>
      <strong>วันเดือนปีเกิด</strong><br />
      {{ data.userdata.dob }}
    </div>
    <br />
    <div>
      <strong>บัตร Next card</strong><br />
      {{ data.userdata.nextCard }}
    </div>
    <br />
    <div>
      <strong>รูปถ่ายใบหน้าตรง</strong><br /><br />
      <v-img
        :src="data.userdata.faceImage"
        width="100px"
        height="100px"
        @click="openImage(data.userdata.faceImage)"
        ><template v-slot:placeholder>
          <v-layout ma-0 fill-height justify-center align-center>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-layout> </template
      ></v-img>
    </div>
    <br />
    <div>
      <strong>รูปถ่ายใบหน้าคู่กับบัตรประชาชน</strong><br /><br />
      <v-img
        :src="data.userdata.idcardImage"
        width="100px"
        height="100px"
        @click="openImage(data.userdata.idcardImage)"
        ><template v-slot:placeholder>
          <v-layout ma-0 fill-height justify-center align-center>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-layout> </template
      ></v-img>
    </div>
    <br />
    <div v-if="data.type == 'phone'">
      <strong>ต้องการเปลี่ยนแปลง</strong><br />
      เบอร์โทรศัพท์
    </div>
    <div v-if="data.type == 'address'">
      <strong>ต้องการเปลี่ยนแปลง</strong><br />
      {{
        data.type == 'address' && data.text1
          ? `${data.text1} ${data.text2 ? `/ ${data.text2}` : ''}`
          : 'ที่อยู่'
      }}
    </div>
    <br />
    <div>
      <strong>ข้อมูลที่ต้องการเปลี่ยน</strong><br />
      <div v-if="data.type == 'phone'">
        {{ data.updateData }}
      </div>
      <div v-else>
        <div>
          บ้านเลขที่:&nbsp; {{ data.updateData.addressNo }},&nbsp;&nbsp;ชั้น:
          {{ data.updateData.floor }}
        </div>
        <div>
          ตึก:&nbsp; {{ data.updateData.building }},&nbsp;&nbsp;ห้อง:&nbsp;
          {{ data.updateData.roomNo }}
        </div>
        <div>
          หมู่:&nbsp; {{ data.updateData.moo }},&nbsp;&nbsp;ซอย:&nbsp;
          {{ data.updateData.soi }}
        </div>
        <div>
          ถนน:&nbsp; {{ data.updateData.street }},&nbsp;&nbsp;แขวง/ตำบล:&nbsp;
          {{ data.updateData.subDistrict }}
        </div>
        <div>
          เขต/อำเภอ:&nbsp; {{ data.updateData.district }},&nbsp;&nbsp;จังหวัด:&nbsp;
          {{ data.updateData.city }},&nbsp;&nbsp; รหัสไปรษณีย์:&nbsp; {{ data.updateData.postCode }}
        </div>
      </div>
    </div>

    <div v-if="data.status == 'pending' || data.status == 'answered'">
      <div
        class="form-control text-xs-left"
        :class="{ 'has-error': errors.has('Approve / Reject') }"
      >
        <v-radio-group
          v-model="selectedChoice"
          :error-messages="!approvetype ? errors.first('Approve / Reject') : ''"
          class="mb-0 pb-0"
          :name="'Approve / Reject'"
          v-validate="'required'"
          :data-vv-as="$t('Approve / Reject')"
        >
          <v-radio value="approve" label="Approve" color="green"></v-radio>
          <v-radio value="reject" label="Reject" color="red"></v-radio>
        </v-radio-group>
      </div>
      <div v-if="selectedChoice == 'reject'" class="mt-2">
        <input
          style="width: 50%"
          placeholder="กรุณาระบุเหตุผล"
          :data-vv-as="$t('สาเหตุที่ Reject')"
          v-validate="'required'"
          :name="'reason'"
          v-model="reason"
          class="form-control"
          type="text"
        />
        <span class="text-error" v-if="errors.has('reason')">
          <span class="red--text">{{ errors.first('reason') }}</span>
        </span>
      </div>
      <div class="text-xs-center mt-2">
        <v-btn @click="saveData" :loading="saveloading" depressed color="primary">ยืนยัน</v-btn>
        <v-btn @click="$emit('close')" color="grey" outline>ยกเลิก</v-btn>
      </div>
    </div>
  </div>
  <div v-else>
    <span class="text-center">ไม่มีข้อมูล</span>
  </div>
</template>

<script>
import api from '@/api'
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedChoice: null,
      reason: '',
      saveloading: false
    }
  },
  methods: {
    async saveData() {
      if (await this.$validator.validateAll()) {
        // set payload to save
        this.saveloading = true
        let payload = {
          ...this.data,
          approveData: {
            name: this.selectedChoice,
            reason: this.reason
          }
        }
        let result = await api.NextCapitalCloseTicket(payload)
        this.saveloading = false
        if (result) {
          this.$swal.fire({ type: 'success', text: 'สำเร็จ' })
          this.$emit('close')
          this.$root.$emit('reloadTickets')
        } else {
          this.$swal.fire({ type: 'error', text: 'เกิดข้อผิดพลาด' })
        }
      }
    },
    openImage(url) {
      window.open(url, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ticket/NextCapitalAgentApprove.vue